import { isEnum } from "../../utils/enum/isEnum.js";
import { roundToPlaces } from "../../utils/roundToPlaces.js";
import { Branch } from "../Branch.js";
import type { TaxLevel } from "../TaxLevel.js";
import type { DeliveryDestination } from "../deliveryDestination.js";
import type { DeliveryDetails } from "../deliveryInfoPerZoneMap.js";
import { calculatePriceWithoutTax } from "./calculatePriceWithoutTax.js";
import { getDeliveryDetails } from "./getDeliveryZone.js";

const isBranch = isEnum(Branch);

export function getPriceOfDelivery(
	taxLevel: TaxLevel,
	priceWithoutDelivery: number,
	destination: DeliveryDestination,
	customDeliveryDetails?: DeliveryDetails,
): { withTax: number; withoutTax: number } | "unreachable" | null {
	if (isBranch(destination)) {
		return {
			withTax: 0,
			withoutTax: 0,
		};
	}

	const deliveryDetails = customDeliveryDetails ?? getDeliveryDetails(destination);
	if (deliveryDetails === null) {
		return null;
	}
	if (deliveryDetails === "unreachable") {
		return "unreachable";
	}

	if (priceWithoutDelivery >= deliveryDetails.freeDeliveryFrom) {
		return {
			withTax: 0,
			withoutTax: 0,
		};
	}

	const withTax = deliveryDetails.priceWithTax;
	return {
		withTax: roundToPlaces(withTax, 2),
		withoutTax: calculatePriceWithoutTax(withTax, taxLevel),
	};
}
